module.exports = {
  acceptedPaymentMethods: 'Accepted Payment Methods',
  'credit-card': 'Credit Card',
  'gift-card': 'Gift Card',
  paypal: 'Paypal',
  affirm: 'Affirm',
};



// WEBPACK FOOTER //
// ./javascripts/translations/accepted_payment_methods/en.js